<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12 md9>
        <h1>
          {{ $auth.currentUser.fullname }}
        </h1>
      </v-flex>

      <v-flex xs12 md3 class="text-xs-center" v-if="showReferralCode && $auth.currentUser.referral_code">
        <span class="grey--text"> {{ $t('attrs.referral_code') }} </span>
        <br />
        {{ $auth.currentUser.referral_code }}
        <br />

        <v-btn flat icon @click="copyReferenceCode">
          <font-awesome-icon icon="copy"></font-awesome-icon>
        </v-btn>

        <v-btn flat icon :href="`whatsapp://send?text=${referralLink}`" data-action="share/whatsapp/share">
          <font-awesome-icon :icon="['fab', 'whatsapp']"></font-awesome-icon>
        </v-btn>

        <!-- <v&#45;btn flat icon :href="fbLink" target="_blank"> -->
        <!--   <font&#45;awesome&#45;icon :icon="['fab', 'facebook']"></font&#45;awesome&#45;icon> -->
        <!-- </v&#45;btn> -->

        <v-btn flat icon :href="twitterLink" target="_blank">
          <font-awesome-icon :icon="['fab', 'twitter']"></font-awesome-icon>
        </v-btn>
      </v-flex>

      <v-flex xs12>
        <v-form @submit.prevent="submit">
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="user.name"
                                  name="name"
                                  :label="$t('attrs.name')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('name')"
                                  data-vv-name="name"
                                  :data-vv-as="$t('attrs.name')"
                                  required
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="user.last_name"
                                  name="last_name"
                                  :label="$t('attrs.last_name')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('last_name')"
                                  data-vv-name="last_name"
                                  :data-vv-as="$t('attrs.last_name')"
                                  required
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="user.company"
                                  name="company"
                                  :label="$t('attrs.company')"
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="user.phone"
                                  name="phone"
                                  :label="$t('attrs.phone')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('phone')"
                                  data-vv-name="phone"
                                  :data-vv-as="$t('attrs.phone')"
                                  required
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="user.email"
                                  name="email"
                                  :label="$t('attrs.email')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('email')"
                                  data-vv-name="email"
                                  :data-vv-as="$t('attrs.email')"
                                  required
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="user.password"
                                  type="password"
                                  name="password"
                                  :label="$t('attrs.password')"
                                  ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="back" :loading="loading" :disabled="loading">{{ $t('cancel') }}</v-btn>
              <v-btn color="primary" dark :loading="loading" :disabled="loading" type="submit">{{ $t('save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Registration from '@/client/registration'
import Setting from '@/client/setting'

export default {
  name: 'ProfileView',

  props: {},

  data () {
    return {
      loading: false,
      user: {},
      referralSetting: {}
    }
  },

  components: {
  },

  computed: {
    showReferralCode () {
      return this.referralSetting.value === '1'
    },

    twitterLink () {
      const link = `http://twitter.com/share?text=${this.company}&url=${this.referralLink}&hashtags=${this.company}`
      return link
    },

    fbLink () {
      const link = `https://www.facebook.com/sharer/sharer.php?u=${this.referralLink}`
      return link
    },

    referralLink () {
      const origin = window.location.origin
      const ref = this.$auth.currentUser.referral_code
      return `${origin}/signup?ref=${ref}`
    }
  },

  methods: {
    async submit () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.loading = true
      try {
        await this.user.save()
        this.setNotification({
          color: 'success',
          message: this.$t('successfullySavedNotification')
        })
        this.$auth.getCurrentUser()
        this.back()
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    async copyReferenceCode () {
      let textArea = document.createElement('textarea')
      textArea.value = this.referralLink
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        document.execCommand('copy')
        this.setNotification({
          color: 'success',
          message: this.$t('coppied')
        })
      } catch (err) {
        this.setNotification({
          color: 'error',
          message: err.message
        })
      }

      document.body.removeChild(textArea)
    }
  },

  watch: {
  },

  async mounted () {
    this.user = new Registration({ ...this.$auth.currentUser })
    this.referralSetting = await Setting.byKey('referral_code')
  }
}
</script>
